export const environment = {
  production: false,
  appVersion: '1.4.1',
  serviceUrl: 'https://staging.api.peech.app',
  gatewayUrl: 'https://peech-gateway-138chblz.uc.gateway.dev',
  amplitudeKey: '4c5c0f44645c543b9b135251300d6b7c',
  clarityProjectId: 'testtest',
  // Deliberately wrong ids so non-prod traffic never pollutes real tracking data
  gtmContainerId: 'GTM-TESTTEST',
  // No tagging server outside prod: the loader falls back to googletagmanager.com,
  // where the wrong container id above resolves to nothing.
  gtmTaggingApexes: [] as string[],
  gtmLoaderPath: '',
  newsbreakPixelId: 'ID-TESTTEST',
  axonEventKey: '00000000-0000-0000-0000-000000000000',
  payPalClientId:
    'AU8LAB0Rnxc_2YGHVQnNwsZQiBIOYbeRKD00fdCuSguLp3Sur0PNQcG1QOD5lRqstUFx_L9KYGdjeZf5',
};
